'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var React = require('react');
var useTextTruncation = require('../../../utils/hooks/useTextTruncation.cjs');
var Tooltip_web = require('../Tooltip/Tooltip.web.cjs');
var Typography_web = require('../Typography/Typography.web.cjs');
var Status_web_styles = require('./Status.web.styles.cjs');

/**
 * A component used to describe the current status of an object
 *
 * {@link https://aviary.fullscript.io/latest/components/status/web-0mEs4REk | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/atoms/Status/Status.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const Status = ({ intention, size = "medium", isFullWidth = false, children, customCss, ...rest })=>{
    const currentTheme = react.useTheme();
    const { textWrapperRef, isTextTruncated } = useTextTruncation.useTextTruncation();
    const intentionStyles = React.useMemo(()=>({
            base: Status_web_styles.status(currentTheme, intention),
            profile: Status_web_styles.profileStyles(currentTheme, intention),
            label: Status_web_styles.label(currentTheme, intention)
        }), [
        currentTheme,
        intention
    ]);
    const sizeStyles = React.useMemo(()=>Status_web_styles.padding(currentTheme, size), [
        currentTheme,
        size
    ]);
    const containerStyles = React.useMemo(()=>[
            intentionStyles.base,
            sizeStyles,
            ...isFullWidth ? [
                Status_web_styles.isFullWidth
            ] : [],
            ...customCss ? [
                customCss
            ] : []
        ], [
        intentionStyles.base,
        sizeStyles,
        isFullWidth,
        customCss
    ]);
    return /*#__PURE__*/ jsxRuntime.jsx(Tooltip_web.Tooltip, {
        tooltipContent: children,
        alignment: "top",
        isTooltipHidden: !isTextTruncated,
        children: /*#__PURE__*/ jsxRuntime.jsxs("div", {
            css: containerStyles,
            "data-testid": "aviary-status",
            "aria-label": children,
            ...rest,
            children: [
                /*#__PURE__*/ jsxRuntime.jsx("span", {
                    css: intentionStyles.profile,
                    "data-testid": "aviary-status-dot"
                }),
                /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                    ref: textWrapperRef,
                    as: "span",
                    variant: "callout",
                    customCss: intentionStyles.label,
                    children: children
                })
            ]
        })
    });
};
Status.displayName = "Status";

exports.Status = Status;
//# sourceMappingURL=Status.web.cjs.map
